import { useCallback } from "react";

import type { LeadsColumnsConfigDto, LeadsSearchColumnListConfig } from "../../types";
import { fromLeadsConfigDtoToColumnOptions } from "../../utils";

import { useColumnsConfigQuery } from "./useColumnsConfigQuery";

export const useColumnsConfigOptionsQuery = (columnConfig: LeadsSearchColumnListConfig) => {
    const transformData = useCallback(
        (data: LeadsColumnsConfigDto) => fromLeadsConfigDtoToColumnOptions(data, columnConfig),
        [columnConfig],
    );

    return useColumnsConfigQuery(transformData);
};
